/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_CreatingInputs */

const en_auth_signup_creating = /** @type {(inputs: Auth_Signup_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating account...`)
};

const de_auth_signup_creating = /** @type {(inputs: Auth_Signup_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto wird erstellt...`)
};

const fr_auth_signup_creating = /** @type {(inputs: Auth_Signup_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création du compte...`)
};

const es_auth_signup_creating = /** @type {(inputs: Auth_Signup_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando cuenta...`)
};

const it_auth_signup_creating = /** @type {(inputs: Auth_Signup_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creazione account...`)
};

const nl_auth_signup_creating = /** @type {(inputs: Auth_Signup_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account wordt aangemaakt...`)
};

const pl_auth_signup_creating = /** @type {(inputs: Auth_Signup_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tworzenie konta...`)
};

const fi_auth_signup_creating = /** @type {(inputs: Auth_Signup_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luodaan tiliä...`)
};

const da_auth_signup_creating = /** @type {(inputs: Auth_Signup_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opretter konto...`)
};

const sv_auth_signup_creating = /** @type {(inputs: Auth_Signup_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapar konto...`)
};

/**
* | output |
* | --- |
* | "Creating account..." |
*
* @param {Auth_Signup_CreatingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_signup_creating = /** @type {((inputs?: Auth_Signup_CreatingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_CreatingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_signup_creating(inputs)
	if (locale === "fr") return fr_auth_signup_creating(inputs)
	if (locale === "es") return es_auth_signup_creating(inputs)
	if (locale === "it") return it_auth_signup_creating(inputs)
	if (locale === "nl") return nl_auth_signup_creating(inputs)
	if (locale === "pl") return pl_auth_signup_creating(inputs)
	if (locale === "fi") return fi_auth_signup_creating(inputs)
	if (locale === "da") return da_auth_signup_creating(inputs)
	if (locale === "sv") return sv_auth_signup_creating(inputs)
	return en_auth_signup_creating(inputs)
});